export const LOAD_MESSAGES = 'LOAD_MESSAGES';
export const SET_TOTAL_COUNT = 'SET_TOTAL_COUNT';
export const SET_FILTERS = 'SET_FILTERS';
export const SET_CURSOR = 'SET_CURSOR';
